import React from "react";

function CookiesPage({ onOpenCookieSettings }) {
  return (
    <div className="container cookies-page-container">
      <div className="cookies-page-header">
        <img src="/logo.png" alt="Student Loan Modeller Logo" className="page-logo" />
        <h1 className="main-title cookies-page-title">Cookies</h1>
        <p className="app-intro cookies-page-intro">
          This page explains what cookies or similar storage are used by SLAM and why.
        </p>
      </div>

      <section className="cookies-section">
        <h2>Necessary Cookies</h2>
        <p>
          At present, SLAM does not set any strictly necessary browser cookies from the frontend application.
        </p>
      </section>

      <section className="cookies-section">
        <h2>Necessary Local Storage</h2>
        <p>
          We store minimal preference data in local storage so your legal and cookie choices are remembered.
        </p>
        <table className="cookies-table" aria-label="Local storage items">
          <thead>
            <tr>
              <th>Name</th>
              <th>Purpose</th>
              <th>Type</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>slam_cookie_consent</td>
              <td>Stores whether analytics is accepted or rejected.</td>
              <td>Local storage</td>
              <td>Until user clears site data or changes preference.</td>
            </tr>
            <tr>
              <td>slam_disclaimer_acceptance</td>
              <td>
                Stores disclaimer acceptance details: acceptance timestamp, disclaimer version, and browser ID.
              </td>
              <td>Local storage</td>
              <td>Until user clears site data or a new disclaimer version requires re-acceptance.</td>
            </tr>
            <tr>
              <td>slam_browser_id</td>
              <td>Stores a random browser identifier used only to evidence disclaimer acceptance events.</td>
              <td>Local storage</td>
              <td>Until user clears site data.</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="cookies-section">
        <h2>Optional Analytics Cookies (Google Analytics 4)</h2>
        <p>
          The Google Analytics cookies are only set after you select <strong>Accept analytics</strong>.
        </p>
        <p>
          If you later reject analytics, you can return to cookie settings at any time and choose accept again to
          re-enable Google Analytics.
        </p>
        <table className="cookies-table cookies-table-first" aria-label="Analytics cookies">
          <thead>
            <tr>
              <th>Name</th>
              <th>Purpose</th>
              <th>Type</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>Distinguishes users for analytics reporting.</td>
              <td>Cookie</td>
              <td>Up to 2 years</td>
            </tr>
            <tr>
              <td>_ga_&lt;container-id&gt;</td>
              <td>Persists session state for GA4.</td>
              <td>Cookie</td>
              <td>Up to 2 years</td>
            </tr>
          </tbody>
        </table>
        <div className="cookies-analytics-detail">
          <h3>Google Analytics Cookies</h3>
          <p>
            We use Google Analytics to help us understand how visitors use our website so that we can improve its
            performance, content and user experience. Google Analytics uses cookies to collect information about how
            visitors interact with the site.
          </p>

          <p className="cookies-subheading">Cookies used</p>
          <p>
            <strong>_ga</strong> <strong>(expires after 2 years)</strong>
          </p>
          <p>
            This cookie is used to distinguish individual visitors by assigning a randomly generated identifier
            (Client ID). It enables us to recognise returning visitors and measure website usage over time. The cookie
            does not store information that directly identifies you.
          </p>

          <p>
            <strong>_ga_&lt;container-id&gt;</strong> <strong>(expires after 2 years)</strong>
          </p>
          <p>
            This cookie is used to maintain session state for our Google Analytics property. It helps us understand
            how visitors interact with the website during and across sessions by recording information such as session
            activity and engagement.
          </p>

          <p className="cookies-subheading">Information collected</p>
          <p>Google Analytics may collect information including:</p>
          <ul className="cookies-detail-list">
            <li>Pages visited and navigation paths.</li>
            <li>Time spent on pages and interactions with the website.</li>
            <li>Device, browser and operating system information.</li>
            <li>Approximate geographic location (such as country or city).</li>
            <li>Referring websites or search engines.</li>
            <li>A pseudonymous client identifier stored in the Google Analytics cookie.</li>
          </ul>
          <p>
            Google receives the IP address associated with requests sent from your browser in order to process
            analytics data and derive approximate location information. Google Analytics 4 does not retain IP
            addresses in analytics reports or store them with your analytics data.
          </p>
          <p>
            We do not use Google Analytics to collect information that directly identifies you, such as your name,
            email address or telephone number, and we do not intentionally send such information to Google Analytics.
          </p>
          <p>
            The information collected is used to produce aggregated reports that help us understand website usage,
            improve our services and monitor the performance of our website.
          </p>
          <p>
            You can change your cookie preferences at any time using our cookie settings.
          </p>
          <p>
            If you withdraw your consent to analytics cookies, we will stop using Google Analytics to collect 
            information about your use of our website. We will also, where technically possible, remove any 
            existing Google Analytics cookies from your device.
          </p>
          <p>
            Withdrawing your consent does not affect the lawfulness of any processing carried out before your consent was withdrawn.
          </p>
        </div>
      </section>

      <div className="cookies-actions">
        <button type="button" className="cookie-btn cookie-btn-secondary" onClick={onOpenCookieSettings}>
          Reopen cookie settings
        </button>
        <a className="cookie-btn cookie-btn-primary" href="/">
          Back to calculator
        </a>
      </div>
    </div>
  );
}

export default CookiesPage;
